var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-top navbar-expand navbar-dark bg-primary border-bottom",class:[
    { 'navbar-expand-md': _vm.expand },
    { 'navbar-transparent': _vm.transparent },
    ( _obj = {}, _obj[("bg-" + _vm.type)] = _vm.type, _obj )
  ],staticStyle:{"padding":"1px 1rem"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMenu),expression:"closeMenu"}],staticClass:"collapse navbar-collapse",class:{ show: _vm.toggled },attrs:{"id":_vm.contentId}},[_vm._t("default",null,{"closeMenu":_vm.closeMenu})],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }